// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root--HX2W1","title":"styles-module__title--YJtBj"};